// Tracking
import mixpanel from "mixpanel-browser";

// i18n
import i18n from '@/plugins/i18n';
import { isBackendMessageShowable } from '@/utils/backend-message-i18n';
import { withMessageReference } from '@/utils/message-reference';

const HTTP_STATUS_KEYS = {
  401: 'http.unauthorized',
  403: 'http.forbidden',
  404: 'http.notFound',
  413: 'http.tooLarge',
  429: 'http.tooManyRequests',
  502: 'http.badGateway',
  503: 'http.serviceUnavailable',
  504: 'http.timeout'
};

function describeRequestError(error) {
  const key = HTTP_STATUS_KEYS[error?.response?.status];

  return key ? i18n.t(key) : i18n.t('http.requestFailed');
}

function toUserMessage(message) {
  if (!message?.isAxiosError) return message;

  return resolveErrorMessage(message, describeRequestError(message));
}

/**
 * Motivo do erro para o usuário: a `mensagem` do backend quando ela existe (já
 * vem com a referência para o suporte); senão, o texto da tela.
 * O interceptor da API rejeita com texto quando não há conexão — ele também vale.
 */
export function resolveErrorMessage(error, fallbackMessage) {
  const data = error?.response?.data;
  const backendMessage = data?.mensagem || data?.message;
  const hasBackendMessage = typeof backendMessage === 'string' && !!backendMessage.trim();

  if (hasBackendMessage && (isBackendMessageShowable(data) || !fallbackMessage)) return backendMessage;

  // Fora do pt-BR, mensagem do backend sem tradução cede lugar ao texto da tela (já traduzido),
  // mantendo o código para o suporte
  if (hasBackendMessage) return withMessageReference(fallbackMessage, error);

  if (typeof error === 'string' && error.trim()) return error;

  return fallbackMessage;
}

function showToast(vm, message, type) {
  const isObject = message && typeof message === 'object';
  const normalizedMessage = isObject && message.message ? message.message : message;
  const normalizedType = type || (isObject ? message.type : undefined) || 'information';
  const toastType = normalizedType === 'info' ? 'information' : normalizedType;

  mixpanel.track(normalizedType, { message: normalizedMessage });

  if (vm.$toast && typeof vm.$toast[toastType] === 'function') {
    const title = i18n.t(`http.toastTitles.${toastType}`);

    vm.$toast[toastType](normalizedMessage, { title });
  }
}

const mixinMessage = {
  data() {
    return {};
  },
  methods: {
    sendMessage(message, type) {
      showToast(this, toUserMessage(message), type);
    },

    /* Erro de chamada ao backend: mostra o motivo que o backend mandou; sem
       resposta dele, o texto da tela. */
    sendErrorMessage(error, fallbackMessage) {
      const statusKey = HTTP_STATUS_KEYS[error?.response?.status];
      const screenMessage = statusKey ? i18n.t(statusKey) : fallbackMessage;

      this.sendMessage(resolveErrorMessage(error, screenMessage), 'error');
    }
  }
};

export default mixinMessage;
